import { createAction, props } from '@ngrx/store';

import { type VarUser } from '@blaze-shared/schema-domain';

import { type IntelliContext } from '../models/intellisense';

const TAG = '[Intellisense]';

export const contextUpdated = createAction(
  `${TAG} Context has been updated`,
  props<{ ctx: IntelliContext }>(),
);

export const updateContext = createAction(`${TAG} Update context`, props<{ varUser?: VarUser }>());
